import React, { useCallback, useEffect, useState } from 'react';
import { icons } from '../../../assets/icons';
import './index.scss';
import { LoaderComponent } from '../../../helpers/components/loader';
import { getDelivery, updateDeliveryStatus } from '../../../api/redux/slices/Admin';
import Pagination from '../../../helpers/components/Pagination';
import { convertDate } from '../../../helpers/modules';
import { CSVLink } from 'react-csv';
import rotateSvg from '../../../assets/icons/svg/rotate-right.svg';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useOnclickOutside from 'react-cool-onclickoutside';
import useStableArr from '../../../utils/useStableArr';
import StatusChangeComponent from '../../../components/navbar/StatusChangeComponent';
import { handleCheck, handleCheckAll } from '../../../utils/checkUtilsAdmin';
import { showToast } from '../../../components/modal';

const DeliveryPage = () => {
    const { delivery, checkedList, total } = useSelector((state) => state.admin);
    const dispatch = useDispatch();
    const params = useParams();
    const [deliveryOpenDropdown, setDeliveryOpenDropdown] = useState(false);
    const [indiceDelivery, setIndiceDelivery] = useState(null);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    const [loadingStatus, setLoadingStatus] = useState(false);
    const ref = useOnclickOutside(() => {
        setDeliveryOpenDropdown(false);
    });

    const [page, setPage] = useState(Number(params.page));
    const [newArr, setNewArr] = useState(delivery?.map((el) => ({ ...el, checked: false })));
    const [isCheck, setIsCheck] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem('accesstoken');
    const [statusDelivery, setStatusDelivery] = useState('');

    const stableDispatch = useCallback(() => {
        setLoading(true);
        dispatch(
            getDelivery({
                token: token,
                page: searchValue || statusDelivery ? 1 : page,
                search: searchValue,
                status: statusDelivery,
            }),
        )
            .unwrap()
            .catch((err) => {
                console.error('Error fetching deliveries:', err);
            })
            .finally(() => setLoading(false));
    }, [dispatch, page, searchValue, token, statusDelivery]);

    useEffect(() => {
        if (token) {
            stableDispatch();
        }
    }, [stableDispatch, token]);

    useStableArr(delivery, checkedList, setNewArr, setIsCheck);

    // ✅ Fermer le dropdown au scroll
    useEffect(() => {
        const handleScroll = () => setDeliveryOpenDropdown(false);
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, []);

    // ✅ Calculer la position exacte du bouton cliqué
    const handleToggleDropdown = (e, id) => {
        const rect = e.currentTarget.getBoundingClientRect();
        if (deliveryOpenDropdown && indiceDelivery === id) {
            setDeliveryOpenDropdown(false);
        } else {
            setDropdownPos({
                top: rect.bottom + 4,
                left: rect.left - 180,
            });
            setDeliveryOpenDropdown(true);
            setIndiceDelivery(id);
        }
    };

    const handleUpdateDeliveryStatus = async (deliveryId, newStatus) => {
        setLoadingStatus(true);
        try {
            await dispatch(updateDeliveryStatus({ token, id: deliveryId, status: newStatus })).unwrap();
            showToast('Statut de livraison mis à jour', 'success');
            stableDispatch();
            setDeliveryOpenDropdown(false);
        } catch (err) {
            showToast(err?.message || 'Erreur lors de la mise à jour', 'error');
        } finally {
            setLoadingStatus(false);
        }
    };

    const headers = [
        { label: 'NUMÉRO', key: 'reference' },
        { label: 'DATE', key: 'createdAt' },
        { label: 'CLIENT', key: 'client_name' },
        { label: 'SOCIÉTÉ', key: 'company_name' },
        { label: 'TOTAL', key: 'company_total' },
        { label: 'PAYÉ', key: 'total_paid' },
        { label: 'RESTE', key: 'remaining_amount' },
    ];

    const csvDeliveryReport = {
        filename: 'Livraisons.csv',
        data: checkedList.map((item) => ({
            reference: item.reference,
            createdAt: convertDate(item.createdAt, 'DD-MM-YYYY'),
            client_name: item.client_name,
            company_name: item.company_name,
            total: item.company_total || 0,
            paid: item.total_paid || 0,
            remaining: item.remaining_amount || 0,
        })),
        headers: headers,
    };

    const listStatusDelivery = [
        { id: '1', label: 'IN_PROGRESS', value: 'En cours' },
        { id: '2', label: 'DELIVERED', value: 'Livré' },
    ];

    return (
        <div id="deliveryPag">
            <div className="navbar">
                <div className="left">
                    <div className="nav-search">
                        <input
                            type="text"
                            placeholder="Rechercher ..."
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e.target.value);
                                setPage(1);
                            }}
                        />
                        <icons.FiSearch className="searchicon" />
                    </div>
                    <StatusChangeComponent
                        statusValue={statusDelivery}
                        setStatusValue={setStatusDelivery}
                        listStatusOptions={listStatusDelivery}
                        name="Livraison"
                    />
                </div>
                <div className="right">
                    <div className="right-items">
                        <CSVLink {...csvDeliveryReport} target="blank">
                            <button className="button-nature" title="exporter livraison(s)">
                                <icons.BiExport />
                            </button>
                        </CSVLink>
                    </div>
                </div>
            </div>
            <div id="head">
                <div className="title-user">
                    <h1>Bons de livraisons</h1>
                </div>
            </div>
            <div id="deliveriesContent">
                <table id="deliveries">
                    <thead>
                        <tr id="titres">
                            <td className="input-check">
                                <input
                                    type="checkbox"
                                    className="checkbox"
                                    checked={isCheck}
                                    onChange={() => handleCheckAll(dispatch, newArr, setNewArr, isCheck, setIsCheck)}
                                />
                            </td>
                            <th>NUMÉRO</th>
                            <th>DATE</th>
                            <th>CLIENT</th>
                            <th>SOCIÉTÉ</th>
                            <th>TOTAL</th>
                            <th>PAYÉ</th>
                            <th>RESTE</th>
                            <td className="center">STATUT</td>
                            <th>ACTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="9">
                                    <LoaderComponent margin="10%" />
                                </td>
                            </tr>
                        ) : newArr?.length > 0 ? (
                            newArr.map((deliveryItem, index) => (
                                <tr 
                                    className="delivery" 
                                    key={index}
                                    // ✅ La ligne active passe au-dessus des autres
                                    style={{ zIndex: deliveryOpenDropdown && indiceDelivery === deliveryItem._id ? 1000 : 1 }}
                                >
                                    <td className="input-check">
                                        <input
                                            type="checkbox"
                                            checked={deliveryItem.checked}
                                            className="checkbox"
                                            onChange={() => handleCheck(dispatch, newArr, setNewArr, deliveryItem._id)}
                                        />
                                    </td>
                                    <td>{deliveryItem?.reference || '-'}</td>
                                    <td>{deliveryItem.createdAt ? convertDate(deliveryItem.createdAt, 'DD-MM-YYYY') : '-'}</td>
                                    <td>{deliveryItem?.client_name || '-'}</td>
                                    <td>{deliveryItem?.company_name || '-'}</td>
                                    <td>{deliveryItem?.company_total != null ? Number(deliveryItem?.company_total).toFixed(2) : 0} DT</td>
                                    <td>{deliveryItem?.total_paid != null ? Number(deliveryItem?.total_paid).toFixed(2) : 0} DT</td>
                                    <td className={deliveryItem?.remaining_amount === 0 ? 'paid-status' : 'remaining-status'}>
                                        {deliveryItem?.remaining_amount != null ? Number(deliveryItem?.remaining_amount).toFixed(2) : 0} DT</td>
                                    <td className="box" style={{ margin: 'auto' }}>
                                        <div
                                            style={{ marginLeft: deliveryItem?.return_id ? '15px' : '' }}
                                            className={`delivery-status ${
                                                deliveryItem.status === 'IN_PROGRESS' ? 'en-cours' : 'confirmer'
                                            }`}
                                        >
                                            {deliveryItem.status === 'IN_PROGRESS' ? 'En cours' : 'Livré'}
                                        </div>
                                        {deliveryItem?.return_id && (
                                            <Link
                                                to={`/admin/returns/return_details/${params.page}/${deliveryItem?.return_id}`}
                                                style={{ display: 'flex' }}
                                            >
                                                <img className="rotate" src={rotateSvg} alt="retour" />
                                            </Link>
                                        )}
                                    </td>
                                    <td className="last-delivery-element">
                                        <Link
                                            to={`/admin/deliveries/delivery_details/${page}/${deliveryItem._id}`}
                                            className="link-delivery"
                                        >
                                            <icons.BsEye className="see-delivery" />
                                        </Link>
                                        <div className="contain">
                                            <icons.BsThreeDotsVertical
                                                onClick={(e) => handleToggleDropdown(e, deliveryItem._id)}
                                                className="delivery-option"
                                            />
                                            {deliveryOpenDropdown && indiceDelivery === deliveryItem._id && (
                                                <div
                                                    className="modalSelectOpt"
                                                    ref={ref}
                                                    style={{
                                                        position: 'fixed',
                                                        top: `${dropdownPos.top}px`,
                                                        left: `${dropdownPos.left}px`,
                                                        zIndex: 99999,
                                                    }}
                                                >
                                                    <ul>
                                                        {deliveryItem.status === 'IN_PROGRESS' && (
                                                            <li onClick={() => handleUpdateDeliveryStatus(deliveryItem._id, 'DELIVERED')}>
                                                                {loadingStatus ? 'Chargement...' : 'Marquer comme livré'}
                                                            </li>
                                                        )}
                                                        <Link to={`/admin/deliveries/payment_details/${deliveryItem._id}`}>
                                                            <li>Détails de paiement</li>
                                                        </Link>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" style={{ textAlign: 'center', padding: '50px' }}>
                                    Aucune livraison trouvée
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination page={page} setPage={setPage} pageLink="/admin/deliveries/" total={total} />
        </div>
    );
};

export default DeliveryPage;